import React, { useEffect, useState } from 'react';
import PCreatePost from '../PCreatePost';
import PostsContent from '../Post/posts-contents';
import { POST_STATUS, ROLES } from '../../utils/constants';
import UserStories from '../UserStories';
import Tab from 'react-bootstrap/Tab';
import Nav from 'react-bootstrap/Nav';
import Meta from '../Meta';
import { connect, useDispatch } from 'react-redux';
import { getCategories, setUser } from '../../../redux/actions';
import { setStashSelectedR, setStashSort, setStashType, setFilterToDate } from '../../../redux/actions/stash';
import Grid2 from '@mui/material/Unstable_Grid2/Grid2';
import { Paper, useMediaQuery } from '@mui/material';

import SubscriptionPriceWidget from './SubscriptionPriceWidget';
import PostUserSearch from '../PostUserSearch';
import UserContents from '../UserContents';
import PerformanceWidget from './PerformanceWidget';
import FooterV2 from '../FooterV2';

import './style.scss';
import '../../private-pages/performance/performance.css';
import DefaultPUWidget from '../../Widgets/PU/Default';
import DefaultWidget from '../../Widgets/SU/Default';

const PUHomepage = ({
    user,
    searchBy,
    users,
    keyword,
}) => {
    const dispatch = useDispatch();
    const isMobile = useMediaQuery('(max-width: 899px)');

    const [refetch, setRefetch] = useState(false);
    const [isPu, setIsPu] = useState(false);
    const [showStories, setShowStories] = useState(false);
    const [key, setKey] = useState('home');

    const handleSuccess = (status) => {
        setRefetch(true);
    };

    useEffect(() => {
        let isMounted = true;
        const pathname = window.location.pathname.replace('/');

        if (user && Object.keys(user) <= 0) {
            dispatch(setUser());
        }

        if (pathname === user.login) {
            setIsPu(false);
        } else {
            setIsPu(true);
        }

        dispatch(getCategories({ all: true }));
        dispatch(setStashSelectedR([]));

        return () => {
            dispatch(setStashType('all'));
            dispatch(setStashSort('DESC'));
            dispatch(setFilterToDate(''));
            return isMounted = false;
        };
    }, []);

    return (
        <div className="container pt-4 mb-4 homepage pu-homepage">
            <Meta />
            <Grid2
                container
                spacing={!isMobile ? 2 : 0}
                className="grid-profile"
                style={isMobile
                    ? {
                        width: '100%',
                        display: 'block',
                    }
                    : {}
                }
            >
                <Grid2 item md={8}>
                    <Tab.Container
                        id="createpost-tabs"
                        activeKey={key}
                        onSelect={(k) => setKey(k)}>
                        <div className="createpost-tabs">
                            <Nav className="createpost-tab-toggle">
                                <Nav.Item
                                    className={`${key === 'home' ? 'active' : ''}`}
                                    onClick={() => { setShowStories(false); }}
                                >
                                    <Nav.Link eventKey="home">Home</Nav.Link>
                                </Nav.Item>
                                <Nav.Item
                                    className={`${key === 'schedule' ? 'active' : ''}`}
                                    onClick={() => { setShowStories(false); }}
                                >
                                    <Nav.Link eventKey="schedule">Schedule</Nav.Link>
                                </Nav.Item>
                                {user.role !== ROLES.SU &&
                                    <Nav.Item
                                        className={`${key === 'story' ? 'active' : ''}`}
                                        onClick={() => { setShowStories(true); }}
                                    >
                                        <Nav.Link eventKey="story">Story</Nav.Link>
                                    </Nav.Item>
                                }
                            </Nav>
                            {
                                key === 'home'
                                    ? <div style={{ flex: 1 }}>
                                        <PostUserSearch searchable={true} />
                                    </div>
                                    : null
                            }
                        </div>

                        {!showStories &&
                            <div className="createpost-container">
                                <PCreatePost
                                    schedule={true}
                                    successHandler={handleSuccess}
                                />
                            </div>
                        }

                        <Tab.Content>
                            <Tab.Pane eventKey="home">
                                {key === 'home'
                                    ? (searchBy === 'creator' && keyword && keyword.length > 0
                                        ? <React.Fragment>
                                            <UserContents />
                                        </React.Fragment>
                                        : <PostsContent
                                            refetch={refetch}
                                            setRefetch={setRefetch}
                                            isPu={isPu}
                                            user={user}
                                            status={POST_STATUS.PUBLISHED}
                                        />
                                    )
                                    : null
                                }
                            </Tab.Pane>
                            <Tab.Pane eventKey="schedule">
                                {key === 'schedule' && <PostsContent
                                    refetch={refetch}
                                    setRefetch={setRefetch}
                                    isPu={isPu}
                                    user={user}
                                    status={POST_STATUS.SCHEDULED}
                                />
                                }
                            </Tab.Pane>
                            <Tab.Pane eventKey="story">
                                {key === 'story' && <UserStories pu="true" />}
                            </Tab.Pane>
                        </Tab.Content>
                    </Tab.Container>
                </Grid2>
                {
                    !isMobile
                        ? <Grid2 item className='pu-homepage__right' md={4}>
                            {
                                user && user.role == ROLES.PU ? <DefaultPUWidget /> : null
                            }
                            {
                                user && user.role == ROLES.SU ? <DefaultWidget /> : null
                            }
                        </Grid2>
                        : null
                }
            </Grid2>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        user: state.user.user,
        searchBy: state.search.type,
        users: state.search.users,
        keyword: state.search.keyword,
    };
};

export default React.memo(connect(mapStateToProps)(PUHomepage));
